// extracted by mini-css-extract-plugin
export default {"comments":"PhotoComments_comments__BL9Lj","single":"PhotoComments_single__dlzCk"};